'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _zarm = require('zarm');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 创建提示
 * @param {string}   content  提示内容
 * @param {number}   duration 自动隐藏时间，默认3000
 * @param {function} onClose  关闭回调
 * @param {string}   type     提示类型，添加图标
 */
var Message = function Message() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  var onClose = arguments[2];
  var type = arguments[3];

  var div = document.createElement('div');

  document.body.appendChild(div);

  _reactDom2.default.render(_react2.default.createElement(_zarm.Toast, {
    visible: true,
    mask: true,
    prefixCls: 'cui-toast',
    stayTime: duration,
    afterClose: function afterClose() {
      // ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
      onClose && onClose();
    },
    content: _react2.default.createElement(
      'div',
      null,
      type ? _react2.default.createElement(_zarm.Icon, { type: type, className: 'cui-icon' }) : null,
      _react2.default.createElement(
        'div',
        null,
        content
      )
    )
  }), div);
};

exports.default = {
  info: function info(content, duration, onClose) {
    return Message(content, duration, onClose, 'info-round-fill');
  },
  success: function success(content, duration, onClose) {
    return Message(content, duration, onClose, 'right-round-fill');
  },
  warning: function warning(content, duration, onClose) {
    return Message(content, duration, onClose);
  },
  error: function error(content, duration, onClose) {
    return Message(content, duration, onClose, 'wrong-round-fill');
  }
};